import { isNullOrUndefined } from "../../helper/utils";
import Splide from '@splidejs/splide';

Vue.component("item-image-carousel-custom", {
    props: {
        maxQuantity: { type: Number, default: 10 },
        imageUrlAccessor: { type: String, default: "url" },
        showThumbs: { type: Boolean, default: true },
        showDots: { type: Boolean, default: true },
        animationStyle: { type: String, default: "standard" },
        pluginPath: { type: String, default: "" }
    },

    inject: {
        itemId: { default: null }
    },

    data() {
        return {
            currentItem: 0,
            splideThumbs: null,
            // NEU: Status für WebP-Unterstützung
            isWebpSupported: false 
        };
    },

    computed: {
        currentVariation() {
            return this.$store.getters[`${this.itemId}/currentItemVariation`];
        },

        carouselImages() {
            return this.orderByPosition(
                this.$options.filters.itemImages(
                    this.currentVariation.images,
                    "urlPreview"
                )
            ).slice(0, this.maxQuantity);
        },

        singleImages() {
            return this.orderByPosition(
                this.$options.filters.itemImages(
                    this.currentVariation.images,
                    this.imageUrlAccessor
                )
            ).slice(0, this.maxQuantity);
        }
    },

    watch: {
        currentVariation: {
            handler(val, oldVal) {
                if (val !== oldVal) {
                    MagicZoom.stop('item-magiczoom');
                    setTimeout(() => {
                        this.reInitialize();
                    }, 1);
                }
            },
            deep: true
        }
    },

    mounted() {
        // NEU: Einmalige WebP-Prüfung beim Mounten
        this.checkWebpSupport();

        this.$nextTick(() => {
            this.loadLightbox().then(() => {
                this.initThumbCarousel();
            }).catch(event => {
                console.log("error while loading lightbox", event);
            });
        });
    },

    methods: {
        // NEU: Methode zur Prüfung der WebP-Unterstützung
        checkWebpSupport() {
            const elem = document.createElement('canvas');
            if (!!(elem.getContext && elem.getContext('2d'))) {
                this.isWebpSupported = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
            }
        },

        // NEU: Diese Methode nutzt du im Template für das :href
        getSmartUrl(url) {
            if (!url) return "";
            return this.isWebpSupported ? url + '.webp' : url;
        },

        getImageCount() {
            return this.carouselImages.length > this.maxQuantity ? this.maxQuantity : this.carouselImages.length;
        },

        reInitialize() {
            console.log("STOP")
            MagicZoom.stop()
            $('.item-img-gallery').removeClass('full-size-image');
            if (this.splideThumbs) {
                this.splideThumbs.refresh();
            }
            this.initCarousel();
        },

        initCarousel() {
            console.log("INIT CAROUSEL");
            setTimeout(function() {
                MagicZoom.start();
            }, 100);
        },

        initThumbCarousel() {
            console.log(this.$refs.thumbs);
            this.splideThumbs = new Splide(this.$refs.thumbs, {
                perPage: 1,
                gap: '16px',
                pagination: true,
                arrows: false,
                mediaQuery: 'min',
                breakpoints: {
                    991: {
                        destroy: true
                    }
                }
            }).mount();
        },

        goTo(index) {
            const $owl = $(this.$refs.single);
            $owl.trigger("to.owl.carousel", [index, 350]);
        },

        orderByPosition(list) {
            if (!list) return [];
            return list.sort((entryA, entryB) => {
                if (entryA.position > entryB.position) return 1;
                if (entryA.position < entryB.position) return -1;
                return 0;
            });
        },

        getAltText(image) {
            return image && image.alternate ? image.alternate : this.$options.filters.itemName(this.currentVariation);
        },

        getImageName(image) {
            return image && image.name ? image.name : this.$options.filters.itemName(this.currentVariation);
        },

        loadLightbox() {
            return new Promise((resolve, reject) => {
                const script = document.querySelector("script#magiczoomscript");
                if (!isNullOrUndefined(script)) {
                    resolve();
                } else {
                    const script = document.createElement("script");
                    script.type = "text/javascript";
                    script.id = "magiczoomscript";
                    script.src = `${ this.pluginPath.replace('ceres','evenabag') }/js/src/plugins/magiczoom.js`;
                    script.addEventListener("load", () => resolve(), false);
                    script.addEventListener("error", event => reject(event), false);
                    document.body.appendChild(script);
                }
            });
        }
    }
});